// Fuente única de los casos de éxito. La consumen:
//  - src/views/casos/FeaturedCase.js (caso destacado) y CasosGrid.js (los 5 restantes)
//  - el ItemList de casosSchema en src/libs/schema.js (vía ITEMLIST_CASES + summary)
//  - el MCP público (public/casos.json generado en build → worker-mcp: ver_caso/listar_casos)
// EDITAR SOLO AQUÍ. ESM puro (sin imports de Next) para importarlo desde next.config.mjs.
//
// Importante: `summary` y los campos bespoke de FeaturedCase (featuredEyebrow/featuredTitle)
// se guardan VERBATIM para que la página y el schema rendericen byte-idéntico a lo validado.
// Score AEO en escala 0–100 (visibilidad). Solo datos reales y auditables.

export const CASES = [
  {
    slug: 'smartdeal',
    name: 'SmartDeal',
    featured: true,
    cat: 'E-commerce · Tecnología',
    sector: 'E-commerce de tecnología reacondicionada (Chile)',
    score: { from: 3, to: 82 },
    months: 6,
    actions: 11,
    desc: 'El primer diagnóstico detectó 14 brechas de visibilidad. Activamos acciones en paralelo, con foco en identidad de marca las primeras 8 semanas, y construcción de reputación más contenido editorial.',
    detail: '0 → 754 citas, cobertura en 5 motores, +33 pts de share-of-voice.',
    summary:
      'SmartDeal — E-commerce de tecnología reacondicionada (Chile): score AEO 3 → 82 en 6 meses, 0 → 754 citas, cobertura en 5 motores, +33 pts de share-of-voice.',
    featuredEyebrow: 'SMARTDEAL · E-COMMERCE',
    featuredTitle: 'De score 3 a 82 en seis meses.',
    metrics: [
      { label: 'SCORE', value: '3 → 82' },
      { label: 'CITAS', value: '0 → 754' },
      { label: 'MOTORES', value: '0 → 5' },
      { label: 'SOV', value: '+33 pts' },
    ],
    quote:
      'Pasamos de no existir para ChatGPT a aparecer en el primer párrafo de respuestas sobre nuestra categoría. La diferencia comercial fue inmediata: 23% más leads inbound trimestrales.',
    author: {
      name: 'Diego Meza',
      attrib: 'CEO · SmartDeal · 2026',
      avatar: '/assets/people/diego-meza.webp',
    },
  },
  {
    slug: 'mad-charlies',
    name: "Mad Charlie's",
    cat: 'E-commerce · Marca regional',
    sector: 'Cervecería artesanal regional',
    score: { from: 1, to: 41 },
    months: 4,
    actions: 7,
    desc: 'Cervecería artesanal regional. Distribución consolidada en bares y tiendas, premio local. Presencia AEO nula en consultas de cervezas artesanales. Foco en reputación local y comunidades especializadas.',
    detail: 'Foco en reputación local y comunidades especializadas.',
    summary:
      "Mad Charlie's — Cervecería artesanal regional: score AEO 1 → 41 en 4 meses con 7 acciones, foco en reputación local y comunidades especializadas.",
  },
  {
    slug: 'tucar',
    name: 'Tucar',
    cat: 'D2C · Movilidad',
    sector: 'Suscripción de autos D2C (Chile)',
    score: { from: 15, to: 82 },
    months: 9,
    actions: 18,
    desc: 'Suscripción de autos en Chile. Sin presencia AEO en un mercado dominado por grandes dealers. Foco en identidad de marca y contenido editorial con prensa de electromovilidad.',
    detail: 'Foco en prensa de electromovilidad.',
    summary:
      'Tucar — Suscripción de autos D2C (Chile): score AEO 15 → 82 en 9 meses con 18 acciones, foco en prensa de electromovilidad.',
  },
  {
    slug: 'breik',
    name: 'Breik',
    cat: 'SaaS B2B · RRHH',
    sector: 'SaaS B2B de workforce management',
    score: { from: 0, to: 43 },
    months: 6,
    actions: 11,
    desc: 'SaaS B2B de workforce management. Reputación offline sólida, presencia AEO nula. 12 brechas detectadas en diagnóstico inicial. Foco en identidad de marca y reputación online.',
    detail: '12 brechas detectadas en el diagnóstico inicial.',
    summary:
      'Breik — SaaS B2B de workforce management: score AEO 0 → 43 en 6 meses con 11 acciones, 12 brechas detectadas en el diagnóstico inicial.',
  },
  {
    slug: 'buildalab',
    name: 'Buildalab',
    cat: 'SaaS B2B · Construcción',
    sector: 'SaaS B2B para construcción',
    score: { from: 22, to: 64 },
    months: 6,
    actions: 9,
    desc: 'Software para construcción. IA para predicción de costos y optimización de proyectos antes de obra. Alta expertise técnica, baja visibilidad AEO en consultas de ingeniería estructural.',
    detail: 'Foco en consultas de ingeniería estructural.',
    summary:
      'Buildalab — SaaS B2B para construcción: score AEO 22 → 64 en 6 meses con 9 acciones, foco en consultas de ingeniería estructural.',
  },
  {
    slug: 'verdesur',
    name: 'Verdesur',
    cat: 'B2B · Economía Circular',
    sector: 'Gestión de residuos y economía circular B2B (Los Lagos, Chile)',
    score: { from: 13, to: 55 },
    months: 4,
    actions: 8,
    desc: 'Gestión de residuos y reciclaje B2B en Los Lagos. Operación consolidada con empresas de industria, presencia AEO nula en consultas sobre economía circular en Chile.',
    detail: '',
    summary:
      'Verdesur — Gestión de residuos y economía circular B2B (Los Lagos, Chile): score AEO 13 → 55 en 4 meses con 8 acciones.',
  },
];

const bySlug = Object.fromEntries(CASES.map((c) => [c.slug, c]));

export const scoreLabel = (c) => `${c.score.from} → ${c.score.to}`;

// Caso destacado (FeaturedCase) y los del grid, en su orden de página actual.
export const FEATURED_CASE = CASES.find((c) => c.featured);
export const GRID_CASES = CASES.filter((c) => !c.featured);

// Orden del ItemList del schema (verbatim al actual): destacado primero, Mad Charlie's al final.
export const ITEMLIST_CASES = [
  'smartdeal',
  'tucar',
  'breik',
  'buildalab',
  'verdesur',
  'mad-charlies',
].map((s) => bySlug[s]);

// Compilado rico para el MCP (public/casos.json).
export const ALL_CASES = ITEMLIST_CASES.map((c) => ({
  name: c.name,
  sector: c.sector,
  score: scoreLabel(c),
  months: c.months,
  actions: c.actions,
  detail: c.detail || undefined,
  resumen: c.summary,
  ...(c.featured ? { metrics: c.metrics, testimonio: c.quote } : {}),
}));
